/** One field's value in a request. Sections are compared on their own, by `sectionChanges`. */
type FieldValue = string | number | string[]

export interface DiffLine {
  text: string
  changed: boolean
}

/**
 * Line-level difference for one field. Only the fields a manager actually
 * changed are ever passed here (FR-19), so HR is not hunting through the role.
 */
export function diffLines(before: FieldValue, after: FieldValue): {
  oldLines: DiffLine[]
  newLines: DiffLine[]
} {
  const toArray = (v: FieldValue) => (Array.isArray(v) ? v : String(v).split('\n'))
  const o = toArray(before)
  const n = toArray(after)
  return {
    oldLines: o.map((text) => ({ text, changed: !n.includes(text) })),
    newLines: n.map((text) => ({ text, changed: !o.includes(text) })),
  }
}

export const FIELD_LABELS: Record<string, string> = {
  title: 'Title',
  level: 'Level',
  location: 'Location',
  payMin: 'Range min ($k)',
  payMax: 'Range max ($k)',
  summary: 'Summary',
  responsibilities: 'Responsibilities',
  skills: 'Required skills',
  quals: 'Qualifications',
  sections: 'Sections',
}
